export enum AuthorizationResult{
    Success,
    Failed,
    Aborted
}